import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCancelSubscription = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.369 4.661a9.25 9.25 0 0 1 11.62.29l1.48-1.481a.75.75 0 1 1 1.061 1.06l-16 16a.75.75 0 0 1-1.06-1.06l1.48-1.481a9.25 9.25 0 0 1-1.885-3.595.75.75 0 0 1 1.45-.388 7.75 7.75 0 0 0 1.5 2.918l10.91-10.909A7.75 7.75 0 0 0 5.04 8.593l3.013-1.004a.75.75 0 0 1 .474 1.423l-4.5 1.5a.75.75 0 0 1-.97-.55l-1-4.5a.75.75 0 0 1 1.465-.325l.489 2.2a9.3 9.3 0 0 1 2.358-2.676m12.976 2.993a.75.75 0 0 1 1 .352 9.25 9.25 0 0 1-12.34 12.34.75.75 0 0 1 .65-1.353A7.75 7.75 0 0 0 18.993 8.655a.75.75 0 0 1 .352-1"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCancelSubscription;
